import React from "react"
import { TwRichTextField } from "../../../root/punks/core/fields/RichTextField"
import { ArrowForwardIcon } from "../../icons"
import CustomListItem from "../../molecules/CustomListItem"
import { FaqItem } from "./types"

interface Props {
  items: FaqItem[]
  onClick: (item: FaqItem) => void
}

const FaqPanelNavbar = ({ items, onClick }: Props) => {
  return (
    <div className="py-4">
      {items.map((item, index) => (
        <CustomListItem
          key={index}
          title={<TwRichTextField value={item.title} />}
          endIcon={<ArrowForwardIcon fontSize={16} />}
          separator
          onClick={() => onClick?.(item)}
        />
      ))}
    </div>
  )
}

export default FaqPanelNavbar
